
<main #scroll>
    <div class="city-search">
        <div class="filtering">
            <form>
                <input type="search" class="form-control" (keyup)="applySearch($event)" placeholder="જિલ્લા શોધો.." />
                <i class="ti ti-search"></i>
            </form>
            <!-- <i class="ti ti-filter"></i> -->
        </div>
    </div>
    <hr>
    <div class="add-district">
        <h5 class="mb-3">જિલ્લાઓ</h5>
        <!-- <app-addedit-district></app-addedit-district> -->
        <div class="loginWraper">
            <form [formGroup]="DistrictForm">
                <div class="form-group">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="district-form-group">
                                <div class="input-grp">
                                    <input type="text" class="form-control" placeholder="જિલ્લાનું નામ"
                                        formControlName="district_name" required="" />
                                    <div *ngIf="submitted && f.district_name.errors" class="error-message">
                                        <small *ngIf="f.district_name.errors?.required" class="text-danger">જિલ્લા નું
                                            નામ જરૂરી
                                            છે.</small>
                                    </div>
                                </div>
                                <button type="submit" *ngIf="buttonclick == false" (click)="districtAdd()"><i
                                        class="ti ti-plus"></i></button>
                                <button type="submit" *ngIf="buttonclick == true" (click)="districtEdit()"><i
                                        class="ti ti-pencil"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="city-list district_list table-responsive">
        <table class="member-list-item">
            <thead>
                <tr>
                    <th class="table-header">જિલ્લો</th>
                    <th class="table-header">સભ્યોની સંખ્યા</th>
                    <th class="table-header">તાલુકાની સંખ્યા</th>
                    <th class="table-header">તાલુકા</th>
                    <th class="table-header">ફેરફાર</th>
                    <th class="table-header">સક્રિય / નિષ્ક્રિય</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data of districtData">
                    <td class="td-spacing">
                        <h5>{{data.district_name}} </h5>
                    </td>
                    <td class="td-spacing">
                        <h5 class="text-primary">{{data.members == 0 ? '-' : data.members}} </h5>
                    </td>
                    <td class="td-spacing">
                        <h5 class="text-primary">{{data.subdivisions  == 0 ? '-' : data.subdivisions}} </h5>
                    </td>
                    <td class="td-spacing">
                        <button (click)="GotoSubdivisionList(data.district_id)" class="btn-common add-btn">
                            <i class="ti ti-plus"></i>
                        </button>
                    </td>
                    <td class="td-spacing">
                        <button (click)="EditDistrict(data)" class="btn-common edit-btn">
                            <i class="ti ti-pencil"></i>
                        </button>
                    </td>
                    <td class="td-spacing">
                        <mat-slide-toggle [(ngModel)]="data.is_active" class="example-margin" 
                            [color]="data.is_active == 1? 'green' : 'red' " (change)="openDialog($event,data)">
                        </mat-slide-toggle>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</main>